import { Loader2 } from "lucide-react";

export function StudySubjectLoading() {
  return (
    <div className="py-24 flex items-center justify-center text-muted-foreground text-sm font-benton">
      <Loader2 className="animate-spin mr-2" size={18} />
      <span>Loading courses…</span>
    </div>
  );
}
